/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SuspectedTradeUserLoader_user$ref: FragmentReference;
export type SuspectedTradeUserLoader_user = {|
  +verifiedTradeStatus: ?string,
  +serviceId: ?string,
  +$refType: SuspectedTradeUserLoader_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "verifiedTradeStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8a0d18fef0fe4f6bfe109dc249ac5913';
module.exports = node;
